import React, { CSSProperties, forwardRef } from 'react';
import classNames from 'clsx';
import type { TypographyProps } from '@mui/material';
import { Typography as TypographyMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_FONT_WEIGHT, CUSTOM_ATTRIBUTE_TEXT_TRANSFORM } from './Typography.api';

import styles from './Typography.module.scss';

type Props = {
  rows?: number;
  fontWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
};

const Typography = forwardRef<HTMLSpanElement, TypographyProps & Props>((props, ref) => (
  <TypographyMUI
    {...omitUndefinedProps({
      ...props,
      rows: undefined,
      fontWeight: undefined,
      textTransform: undefined,
      [CUSTOM_ATTRIBUTE_FONT_WEIGHT]: props.fontWeight,
      [CUSTOM_ATTRIBUTE_TEXT_TRANSFORM]: props.textTransform,
    })}
    className={classNames(
      styles.Typography,
      {
        [styles.Typography___clamped]: typeof props.rows === 'number' && props.rows > 1,
      },
      props.className,
    )}
    noWrap={props.noWrap || props.rows === 1}
    style={
      {
        ...(props.style || {}),
        '--internal-line-clamp': typeof props.rows === 'number' && props.rows > 1 ? props.rows : undefined,
      } as CSSProperties
    }
    ref={ref}
  />
));

Typography.displayName = 'Typography';

export default Typography;
